import ShortLinkRedirect from '../components/redirect/short-link.jsx';

const ShortLink = () => <ShortLinkRedirect />;

export default ShortLink;

